<template>
  <div>
    <el-container class="container">
      <el-header height="30px" class="no-padding header">
        <span v-text="showTitle"></span>
      </el-header>
      <el-main class="no-padding main lum-scrollbar">
        <input type="file" ref="fileCustomEmoji" accept="image/*" style="display: none" @change="customUploadEmoji"/>

        <!-- 自定义表情 -->
        <div
          v-for="item in emojiItem.slice(1)"
          v-show="item.emoticon_id == showEmoticonId"
          :key="item.emoticon_id"
          class="emoji-box"
        >
          <div
            v-if="item.emoticon_id == 0"
            class="emoji-item custom-emoji"
            @click="$refs.fileCustomEmoji.click()"
          >
            <i class="el-icon-picture" />
            <span>上传文件</span>
          </div>
          <div v-if="userSelfFiles.content.length === 0" style="padding-top: 25px; padding-left: 105px;">请上传文件</div>
          <div
            v-for="(subitem, index) in userSelfFiles.content"
            class="emoji-item"
            :key="index"
            @click="clickImageEmoticon(subitem)"
          >
            <el-image :src="subitem.fileUrl" fit="cover" />
          </div>
          <div class="clear"></div>
        </div>
      </el-main>
    </el-container>

    <MeEditorSystemEmoticon
      v-if="systemEmojiBox"
      @close="systemEmojiBox = false"
    />
  </div>
</template>

<script>
import MeEditorSystemEmoticon from '@/components/dashboard/main/chat/widgets/editor/MeEditorSystemEmoticon'
import { emojiList as emoji } from '@/util/emojis'
import { mapState, mapGetters, mapActions } from 'vuex'
const constants = require('@/util/constants')
import bus from '@/util/eventbus'

export default {
  name: 'MeEditorEmoticon',
  components: {
    MeEditorSystemEmoticon,
  },
  computed: {
    ...mapGetters([ 'userInfo', 'userSelfFiles' ]),
    ...mapState({
      emojiItem: state => state.emoticon.items,
    }),
  },
  data() {
    return {
      emoji,
      // 系统表情包套弹出窗
      systemEmojiBox: false,
      //
      showEmoticonId: 0,
      // showTitle: 'QQ表情/符号表情',
      showTitle: '文件管理器',
      //
      page: 1,
      pageSize: 13,
      // 接收图片服务器地址
      uploadImageServerUrl: constants.UPLOAD_FILE_URL_V2,
    }
  },
  created() {
    // this.$store.commit('LOAD_USER_EMOTICON')
  },
  mounted() {
    let app = this
    bus.$on(constants.EVENT_BUS_SHOW_FILES_POPOVER, () => {
      // console.log('EVENT_BUS_SHOW_FILES_POPOVER')
      app.query()
    })
  },
  methods: {
    ...mapActions([ 'queryFiles', 'addFile' ]),
    query () {
      let payload = { page: 0, size: 20, type: 'file' }
      this.queryFiles(payload)
    },
    // 选中表情
    clickEmoticon(emoji) {
      this.callback({
        type: 1,
        value: emoji,
      })
    },

    // 发送图片表情包
    clickImageEmoticon(item) {
      console.log('clickImageEmoticon:', item)
      this.callback({
        type: 2,
        value: item.fileUrl,
      })
    },

    callback(data) {
      this.$emit('selected', data)
    },

    // 自定义上传表情
    customUploadEmoji(e) {
      if (e.target.files.length == 0) {
        return false
      }
      //
      let file = e.target.files[0]
      this.uploadImage(file)
    },

    uploadImage (file) {
      //
      let filename = moment(new Date()).format('YYYYMMDDHHmmss')
      if (file.type === 'image/jpeg') {
        filename = filename + '.jpg'
      } else if (file.type === 'image/png') {
        filename = filename + '.png'
      }
      //
      var formdata = new FormData();
      formdata.append("file_name", filename);
      formdata.append("username", this.userInfo.username);
      formdata.append("file", file);
      formdata.append("client", 'web');
      //
      let app = this
      $.ajax({
        url: this.uploadImageServerUrl,
        contentType: false,
        cache: false,
        processData: false,
        mimeTypes:"multipart/form-data",
        type: "post",
        data: formdata,
        success:function(response) {
          // upload response: https://bytedesk.oss-cn-shenzhen.aliyuncs.com/images/20220701112852.png
          console.log('upload response:', response.data)
          let payload = response.data
          app.addFile(payload)
        },
        error: function(error) {
          console.log(error)
          // app.$message.error(app.$t('uploadfailed'))
          // app.$notify({ title: app.$t('tip'), message: app.$t('sendImageError'), type: 'error' })
        }
      })
    },

  },
}
</script>
<style lang="less" scoped>
.container {
  height: 300px;
  width: 500px;
  background-color: white;

  .header {
    line-height: 30px;
    font-size: 13px;
    font-weight: 400;
    padding-left: 5px;
    user-select: none;
    position: relative;
    border-bottom: 1px solid #fbf5f5;

    .addbtn {
      position: absolute;
      right: 10px;
      top: 1px;
      color: #409eff;
      cursor: pointer;
    }
  }

  .footer {
    background-color: #eff1f7;

    .toolbar-items {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .toolbar-item {
        height: 30px;
        width: 30px;
        margin: 0 2px;
        background-color: #fff;
        display: inline-block;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        img {
          width: 20px;
          height: 20px;
        }

        .title {
          display: none;
          position: absolute;
          top: -25px;
          left: 0px;
          height: 20px;
          line-height: 20px;
          background: #353434;
          color: white;
          min-width: 30px;
          font-size: 10px;
          padding-left: 5px;
          padding-right: 5px;
          border-radius: 2px;
          white-space: pre;
          text-align: center;
        }

        &:hover .title {
          display: block;
        }
      }
    }
  }
}

.container .footer .toolbar-items .prev-page:active i,
.container .footer .toolbar-items .next-page:active i {
  transform: scale(1.2);
}

.emoji-box,
.emoticon {
  width: 100%;
}

.emoticon {
  .title {
    width: 50%;
    height: 25px;
    line-height: 25px;
    color: #ccc;
    font-weight: 400;
    padding-left: 3px;
    font-size: 12px;
  }

  .emoticon-item {
    width: 30px;
    height: 30px;
    margin: 2px;
    float: left;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      transform: scale(1.3);
    }
  }

  .symbol {
    font-size: 22px;
  }
}

.emoji-box {
  .emoji-item {
    width: 67px;
    height: 67px;
    margin: 2px;
    background-color: #eff1f7;
    float: left;
    cursor: pointer;
    transition: ease-in 0.3s;
  }

  .custom-emoji {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 10px;

    i {
      font-size: 30px;
      margin-bottom: 3px;
    }

    &:active {
      color: #409eff;
    }
  }
}

/deep/ .el-image {
  width: 100%;
  height: 100%;
  transition: ease-in 0.3s;
}

.emoji-box .emoji-item:hover .el-image,
.emoji-box .emoji-item:hover {
  border-radius: 10px;
}
</style>
